export const APP_VERSION = 'v1.3.0';

export const GROQ_MODEL      = 'openai/gpt-oss-120b';
// llama-3.1-8b-instant was deprecated by Groq (2026-06-17 notice) and now
// 404s on every call — switched to Groq's own recommended replacement.
export const GROQ_MODEL_FAST = 'openai/gpt-oss-20b';

export const IS_DEV = process.env.NODE_ENV === 'development';

// All third-party API keys are server-side only (api/events.js, api/photo.js)

// 前台頁籤用中文分類（購物/飲食…），存檔時要把英文 key 換成中文才對得上
export const categoryMood = (categories, key) =>
  categories.find(c => c.key === key)?.mood || key;
